import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Sidebar } from './Dashboard';

const API = 'https://tribaltech-backend.onrender.com';

export default function Analytics() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [connecting, setConnecting] = useState(false);

  const token = localStorage.getItem('tribal_token');
  const headers = { Authorization: 'Bearer ' + token };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('connected')) {
      loadData();
    } else {
      loadData();
    }
  }, []);

  const loadData = async () => {
    try {
      const r = await axios.get(API + '/api/analytics/search', { headers });
      setData(r.data);
    } catch (e) {
      setData({ connected: false });
    }
    setLoading(false);
  };

  const connectGoogle = async () => {
    setConnecting(true);
    try {
      const r = await axios.get(API + '/api/auth/google', { headers });
      window.location.href = r.data.url;
    } catch (e) {
      alert('Failed to connect Google: ' + e.message);
      setConnecting(false);
    }
  };

  const maxClicks = data?.queries?.length > 0
    ? Math.max(...data.queries.map(q => q.clicks || 0))
    : 1;

  return (
    <div className="page">
      <Sidebar />
      <div className="main">
        <div className="page-title">Search Analytics</div>

        {loading ? (
          <div className="card" style={{ color:'var(--muted)' }}>Loading...</div>
        ) : !data?.connected ? (
          <div className="card" style={{ textAlign:'center', padding:'48px 20px' }}>
            <div style={{ fontSize:40, marginBottom:16 }}>📊</div>
            <h3 style={{ fontSize:18, marginBottom:8 }}>Connect Google Search Console</h3>
            <p style={{ color:'var(--muted)', fontSize:14, marginBottom:24, maxWidth:400, margin:'0 auto 24px' }}>
              See exactly what search terms people use to find your content — and which kinks, names, and phrases drive the most traffic to your profile.
            </p>
            <button
              className="btn btn-primary"
              style={{ fontSize:14, padding:'12px 28px' }}
              onClick={connectGoogle}
              disabled={connecting}
            >
              {connecting ? 'Connecting...' : 'Connect Google Search Console →'}
            </button>
            <div style={{ marginTop:16, fontSize:12, color:'var(--muted)' }}>
              You need to verify your OnlyFans URL in Google Search Console first
            </div>
          </div>
        ) : (
          <>
            <div style={{ marginBottom:20, fontSize:13, color:'var(--muted)' }}>
              Top search queries driving traffic to your profile — last 90 days
            </div>

            <div className="card" style={{ marginBottom:20 }}>
              <h3 style={{ fontSize:15, marginBottom:20 }}>Top search terms</h3>
              {(data?.queries || []).length === 0 ? (
                <div style={{ color:'var(--muted)', textAlign:'center', padding:'20px 0' }}>
                  No search data yet. Data appears after Google indexes your pages.
                </div>
              ) : (
                data.queries.map((q, i) => (
                  <div key={i} style={{ marginBottom:14 }}>
                    <div style={{ display:'flex', justifyContent:'space-between', marginBottom:4 }}>
                      <span style={{ fontSize:13, fontWeight: i < 3 ? 600 : 400 }}>{q.keys?.[0] || '—'}</span>
                      <div style={{ display:'flex', gap:16, fontSize:12, color:'var(--muted)' }}>
                        <span>{q.clicks || 0} clicks</span>
                        <span>{q.impressions || 0} impressions</span>
                        <span>{((q.ctr || 0) * 100).toFixed(1)}% CTR</span>
                        <span>pos {(q.position || 0).toFixed(1)}</span>
                      </div>
                    </div>
                    <div style={{ background:'var(--bg2)', borderRadius:4, height:6 }}>
                      <div style={{
                        background: i < 3 ? 'var(--purple)' : 'var(--border)',
                        borderRadius:4,
                        height:6,
                        width: (((q.clicks || 0) / maxClicks) * 100) + '%',
                        transition:'width 0.3s',
                      }} />
                    </div>
                  </div>
                ))
              )}
            </div>

            <div className="card">
              <h3 style={{ fontSize:15, marginBottom:16 }}>What this means</h3>
              <div style={{ fontSize:13, color:'var(--muted)', lineHeight:1.8 }}>
                <div>• Use your top search terms as video titles and tags on OnlyFans</div>
                <div>• Terms with high impressions but low CTR need better thumbnails</div>
                <div>• Partner names that appear often are good for future collabs</div>
                <div>• Position under 10 means you're on page 1 of Google</div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
